import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import BudgetItemsRequestedFromSomanAdd from "../../Submitter/WorkPlanEstimatedBudget/BudgetItemsRequestedFromSoman/BudgetItemsRequestedFromSomanAdd";
import Swal from "sweetalert2";
import { DeleteBudgetItemsRequestedFromSomanById } from "../../../Redux/Reducers/Submitter/BudgetItemsRequestedFromSoman";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import TableAHSF from "../../../Components/TableAHSF";
import { decryptToken } from "../../../Services/Encryption/EncryptionToken";
import PopupAHSF from "../../../Components/PopupAHSF";

const BudgetItemsRequestedFromSomanManager = (props) => {
  const [PopupComponentEditStatus, setPopupComponentEditStatus] =
    useState(false);
  const [BudgetItemsRequestedFromSomanId, setBudgetItemsRequestedFromSomanId] =
    useState(null);
  const AppGuid = useParams();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      // ActiveRound: state.ApplicationInformation.ActiveRound,
      SpecificTask:
        state.TasksByRoundAndFiled.SpecificTask?.applicationInformationId,
    };
  });
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},

    componentBody: (
      <BudgetItemsRequestedFromSomanAdd
        shouldDisableFields={props.shouldDisableFields}
      />
    ),
    maxWidth: "900px",

    maxHeight: "500px",
    title: "بنود الموازنة المطلوبة من مؤسسة عبد الحميد شومان",
  };
  const RequestsColumns = [];

  const RequestAccessor = [
    {
      KeyName: "itemNameDropDown",
      ShowStatus: true,
      NmaeColumn: "نوع البند",
      TotalNumber: false,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemName",
      ShowStatus: true,
      NmaeColumn: "اسم البند",
      TotalNumber: false,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemDescription",
      ShowStatus: true,
      NmaeColumn: "وصف البند",
      TotalNumber: false,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "numberOfUnits",
      ShowStatus: true,
      NmaeColumn: "عدد الوحدات",
      TotalNumber: false,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "unitPrice",
      ShowStatus: true,
      NmaeColumn: "سعر الوحدة",
      TotalNumber: false,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "total",
      ShowStatus: true,
      NmaeColumn: "المجموع",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];

  const OtherMainBtns = [
    {
      Click: async (e) => {
        setBudgetItemsRequestedFromSomanId(e.target.value);
        closePopupEditComponent();
      },
      content: "",
      className: "",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
  ];
  const closePopupEditComponent = () => {
    if (PopupComponentEditStatus) {
      setPopupComponentEditStatus(false);
    } else {
      setPopupComponentEditStatus(true);
    }
  };
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [state.SpecificTask]);
  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"budgetItemsRequestedFromSomanId"}
        valueButtonAction={"budgetItemsRequestedFromSomanId"}
        URL={`api/SU_NT_WPB_BudgetItemsRequestedFromSoman/GetAllBudgetItemsRequestedFromSomanByAppGuid`}
        UrlBody={{
          applicationInformationId: state.SpecificTask,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={true}
        arrayButton={OtherMainBtns}
        arrayButtonLastIndex={false}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
      />

      <PopupAHSF
        title={"بنود الموازنة المطلوبة من مؤسسة عبد الحميد شومان"}
        componentBody={
          <BudgetItemsRequestedFromSomanAdd
            ViewData={true}
            disabledData={false}
            Action={"view"}
            BudgetItemsRequestedFromSomanId={BudgetItemsRequestedFromSomanId}
            // shouldDisableFields={props.shouldDisableFields}
          />
        }
        maxWidth="900px"
        maxHeight="500px"
        isPopupOpenStatus={PopupComponentEditStatus}
        isPopupOpenFunction={closePopupEditComponent}
      />
    </>
  );
};

export default BudgetItemsRequestedFromSomanManager;
